import React from 'react';
import styled from 'styled-components';

const Icon = styled.i`
  font-size: ${props => props.fontSize || '18px'};
  color: ${props =>
    props.productIsFavourite
      ? props.theme.favouriteIconHovorColor
      : props.theme.editIconFontColor};
  cursor: pointer;
  align-self: ${props => (props.shouldAlignCenter ? 'center' : 'initial')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

  &:hover {
    color: ${props =>
      props.theme.productIsFavourite
        ? props.theme.favouriteIconHovorColor
        : props.theme.favouriteIconHovorInactiveColor};
    transition: all 0.25s ease;
  }
`;

const FavouriteIcon = props =>
  props.productIsFavourite ? (
    <Icon
      id="FavouriteIcon-heart"
      className="fa fa-heart"
      {...props}
      onClick={e => {
        props.onClick();
        e.stopPropagation();
      }}
    />
  ) : (
    <Icon
      id="FavouriteIcon-heart"
      className="far fa-heart"
      {...props}
      onClick={e => {
        props.onClick();
        e.stopPropagation();
      }}
    />
  );

export default FavouriteIcon;
